/**
 * 模块: Keyword Column Utils
 * 职责: 关键词表格列工具函数
 * 限制: <280行
 */

import React from 'react';

/**
 * 获取百分比对应的样式class
 */
export const getPercentClass = (
  value: number,
  thresholds: { excellent: number; good: number; moderate: number }
): string => {
  if (value >= thresholds.excellent) return 'metric-excellent';
  if (value >= thresholds.good) return 'metric-good';
  if (value >= thresholds.moderate) return 'metric-moderate';
  return 'metric-poor';
};

/**
 * 渲染增长率（带箭头和颜色）
 */
export const renderGrowthRate = (value: number): React.ReactNode => {
  if (value === null || value === undefined) return '-';
  const color = value > 0 ? '#52c41a' : value < 0 ? '#f5222d' : '#666';
  const arrow = value > 0 ? '↑' : value < 0 ? '↓' : '';
  return (
    <span style={{ color }}>
      {arrow} {Math.abs(value).toFixed(1)}%
    </span>
  );
};

/**
 * 渲染百分比（带样式）
 */
export const renderPercent = (
  value: number,
  thresholds: { excellent: number; good: number; moderate: number }
): React.ReactNode => {
  if (value === null || value === undefined) return '-';
  const className = getPercentClass(value, thresholds);
  return <span className={`metric-value ${className}`}>{value.toFixed(1)}%</span>;
};

/**
 * 渲染排名（带千分位）
 */
export const renderRank = (value: number): React.ReactNode => {
  return value ? <span className="rank-cell">{value.toLocaleString()}</span> : '-';
};

/**
 * 排名排序器（null/undefined视为最大值）
 */
export const rankSorter = (a: any, b: any, field: string): number => {
  const aVal = a[field] ?? Infinity;
  const bVal = b[field] ?? Infinity;
  return aVal - bVal;
};

/**
 * 指标排序器（支持嵌套路径）
 */
export const metricSorter = (a: any, b: any, metric: string): number => {
  return (a.metrics?.[metric] || 0) - (b.metrics?.[metric] || 0);
};

